import React from "react";
import styled from 'styled-components';
import InputSubTitleClaroSocio from '../../../molecules/InputSubtitleClaroSocio';
import InputTitleClaroSocio from '../../../molecules/InputTitleClaroSocio';
import ClaroImage from '../../../molecules/ClaroImage'
import { Link } from "react-router-dom";
import ClaroInputField from "../../../atoms/ClaroInputField";
import ClaroDiv from "../../../atoms/ClaroDiv";
import ClaroInputButton from "../../../atoms/ClaroInputButton"
import {
    SERVICE_ID_TELCEL_POSPAGO,
    SERVICE_ID_TELCEL_PLANES,
    AMIGO_PAGUITOS,
    SERVICE_ID_TELCEL_RECARGA
  } from '../../../../constants';
import { validationStyles } from '../utils/index'
import { getTagServiceId, getListFavsServices, getCanManageFavorites,getListReminder,getListRecentlyPaid, selectContactNumberData  } from '../../../../store/selectors/paymentsSelectors';
import { getPaymentReminder } from '../../../../store/actions/payReminder';
import { getFavoritosRef, addFavoritesRef, deleteFavoritesRef } from '../../../../store/actions/favoritosRef';
import { executeTaggeo,setNumberContact } from "../../../../store/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CreateFavoriteService from "../../../molecules/createFavoriteService";

const Container = styled.div`
    width: 100%%;
    background: ${props => props.background ? props.background : "#fff"};
    margin: ${props => props.margin ? props.margin : "2%"};
`;

const SrOnly = styled.span`
	position: absolute;
	width: 1px;
	height: 1px;
	margin: -1px;
	padding: 0;
	overflow: hidden;
	clip: rect(0, 0, 0, 0);
	border: 0;
`;

const HelpText = styled.p`
  font-family: AMX-Regular;
  font-size: 13px;
  margin: 6px 0px 0px 0px;
  color: red;
`

export default class ContactInputClaroSocio extends React.Component {

    constructor(props, context){
        super(props, context);
        this.state = {
            isFocused: false,
            phoneNumber: undefined,
            alias: undefined,
            saveCard: false,
            dispatchedFromAgenda:false
        }
    }

    componentDidMount() {
        if(this.props.favoritos && !this.props.isContainerTelcel && this.props.canManageFavorites){
            this.assignTagServiceTelcel(this.props.serviceId);
        }
        /* 
        * Esto se debe a que en flujo de agenda y guardado de servicio el componente se desmonta al trasladarse a la ruta
        * de contactos, lo que genera que se pierda la referencia del componente en memoria de lo que es un "prevProps"
        * o "nextProp", lo que a su vez provoca que no se pueda diferenciar de un número de agenda nuevo al anterior
        * y finalmente ocasiona que se sobreescriba el estado local con el setState() en el phoneNumber cada vez que 
        * existe un efecto secundario desde el store. Esto provoca que el número pese a actualizarse de forma manual en el input
        * quede con la referencia anterior de redux. Si fuera un componente controlado sería diferente el caso,
        * o si no se usaran dos mecanismos de estado al mismo tiempo. Favor de no ocupar el action creator asociado a este valor
        * en algún otro flujo ajeno para evitar efectos secundarios indeseados. 
        */
        if(this.props.numberFromAgenda){
            const {isContainerTelcel,favoritos,canManageFavorites} = this.props;
            if(favoritos && !isContainerTelcel && canManageFavorites){
                this.setState({
                    phoneNumber: this.props.numberFromAgenda,
                    alias: undefined,
                    dispatchedFromAgenda:true
                })
            }
         }
    }

    componentDidUpdate(prevProps,prevState) {
        const {listReminder,listRecentlyPaid,favoritos,isContainerTelcel,canManageFavorites,canPaymentReminder,listFavServices,value,getFavoritosRef,hasFavsSuccess,updatePaymentReminderSucces} = this.props
        if(favoritos && !isContainerTelcel && canManageFavorites){
            if(canPaymentReminder){
                if(!this.state.alias && this.state.phoneNumber && !this.state.saveCard && listReminder !== undefined){
                    if(this.state.dispatchedFromAgenda){
                   this.props.handleInputChange({ target: { name: 'destAccountId', value: this.props.numberFromAgenda } }, this.props.input.type);
                    this.setState({ dispatchedFromAgenda: false });
                    };
                    this.handleAsignPhone();
                  }
            }else{
                if(!this.state.alias && this.state.phoneNumber && !this.state.saveCard && listFavServices !== undefined){
                    if(this.state.dispatchedFromAgenda){
                    this.props.handleInputChange({ target: { name: 'destAccountId', value: this.props.numberFromAgenda } }, this.props.input.type);
                    };
                    this.handleAsignPhone();
                  }
            }
       
        if(value && value !== prevProps.value){
            if(!listFavServices && !canPaymentReminder){
                getFavoritosRef('findFavoriteMicroApp', this.state.tagServiceId);
            }
            if(canPaymentReminder ){
               getPaymentReminder(); 
            }
            this.handleValidateLength(value,this.props.input);      
          }

          if(!value && value !== prevProps.value){
            this.props.handleInputChange({target:{ name:this.props.input.field.input.name, value: value}}, this.props.input.type);
            this.setState({ alias: undefined });   
            this.setState({ phoneNumber: undefined }); 
            if(!listFavServices && !canPaymentReminder){
                getFavoritosRef('findFavoriteMicroApp', this.state.tagServiceId);
            }
            if(canPaymentReminder ){
                getPaymentReminder(); 
            }
          }

          if(hasFavsSuccess.alias && hasFavsSuccess.alias !== prevProps.hasFavsSuccess.alias){
            if(value === hasFavsSuccess.accountService){
                this.setState({ alias: hasFavsSuccess.alias });
            }
            
        }
        if(updatePaymentReminderSucces !== prevProps.updatePaymentReminderSucces ){
            const listAll = [...listReminder,...listRecentlyPaid]
            const Reference = listAll.find(service => {
                return service.idReminder === updatePaymentReminderSucces.data.idReminder;
            })
            if(Reference.accountService === value){
            this.setState({ alias: updatePaymentReminderSucces.data.alias });
            }
        }
       
        }

         if(this.state.dispatchedFromAgenda){
                   this.props.handleInputChange({ target: { name: 'destAccountId', value: this.props.numberFromAgenda } }, this.props.input.type);
                    this.setState({ dispatchedFromAgenda: false });
                    };
    }

    assignTagServiceTelcel(serviceId) {
        let newTagServiceId;
    
        switch (true) {
            case (serviceId === SERVICE_ID_TELCEL_PLANES):
                newTagServiceId = 'telcelAmigoSinLimitePs';
                break;
            case (serviceId === SERVICE_ID_TELCEL_POSPAGO):
                newTagServiceId = 'TelcelPospagoPS';
                break;
            case (serviceId === AMIGO_PAGUITOS):
                newTagServiceId = 'amigopaguitos';
                break;
            case (serviceId === SERVICE_ID_TELCEL_RECARGA):
                newTagServiceId = 'serviciopagotelcel';
                break;
            default:
                newTagServiceId = this.props.tagServiceId;
        }
    
        if (this.state.tagServiceId !== newTagServiceId) {
          this.setState({ tagServiceId: newTagServiceId })
          if(!this.props.canPaymentReminder){
            this.props.getFavoritosRef('findFavoriteMicroApp', newTagServiceId);
            }else{
              this.props.getPaymentReminder();
            }
          };
    }

    handleImagenClick = () => {
        this.props.executeTaggeo({
            action: "Click Guardar Servicio",
            step: "Formulario de pago",
            service: this.state.tagServiceId,
        })
        this.setState({ saveCard: true });
    };

    handleCloseModal = (props) => {
        this.setState({ saveCard: false })
        if(this.props.canPaymentReminder){
            this.props.getPaymentReminder();
        }else{
            this.props.getFavoritosRef('findFavoriteMicroApp', this.state.tagServiceId);
        }
    }

    handleValidateLength = (e,input) =>{
        let inputNumber
        if(!this.props.inputValue){
          inputNumber = e.target.value
        }else{
            this.props.handleInputChange({target:{ name:this.props.input.field.input.name, value: this.props.inputValue}}, this.props.input.type);
            inputNumber = e;
        }
        const {isValid,isContainerTelcel,isClaroPartner,canManageFavorites,favoritos,serviceId,serviceInfo} = this.props;
        const {phoneNumber,alias,saveCard,isFocused} = this.state;
        if(favoritos && !isContainerTelcel && canManageFavorites && !this.props.isClaroPartner){
                if (e.length >= input.field.input.truncateValue) {
                    const trimmedValue = e.slice(0, input.field.input.truncateValue);
                    this.setState({ phoneNumber: trimmedValue });
                    this.setState({ alias: undefined });
                } else {

                    this.setState({ phoneNumber: undefined, alias: undefined });
                }   
    }
    }

    handleAsignPhone = () =>{
        
        let foundService ={};
        if(this.props.canPaymentReminder){
            const list = [...this.props.listReminder,...this.props.listRecentlyPaid]
            const allList = list.filter(fav => fav.serviceName === this.state.tagServiceId)
         foundService = allList.find(service => {
                return service.accountService === this.state.phoneNumber;
            })
        }else{
            foundService = this.props.listFavServices.find(service => {
                return service.accountService === this.state.phoneNumber;
            })
        }
         
        if (foundService) {
            const foundValue = foundService["alias"];
            if(foundValue !== ''){
                this.setState({ alias: foundValue });
            }
            
        }
        
    }
    
    render(){
        const {phoneNumber,alias,saveCard,tagServiceId, isFocused} = this.state;
        let { 
            input :{ id, field: {input, button}, title, type, subTitle}, 
            serviceName, 
            isValid, 
            canManageFavorites,
            favoritos,
            setDefaultValue, 
            handleInputChange,
            constraints,
            handleClickTooltip,
            handleInputButtonFunction,
            serviceId,
            isClaroPartner,
            isContainerTelcel,
            serviceTA
        } = this.props
        if (isContainerTelcel && !isClaroPartner) {
            button = {
                ...button,
                src: '/images/icono_agenda.png',
                width: '22.6',
                height: '27'
            }
        }

        let validation = validationStyles(isValid, isContainerTelcel, isClaroPartner);
        let value = (this.props.setDefaultValue) ? input.value : this.props.inputValue;
        const styles = {
            "color": validation.validInvalidColor,
            "borderBottom": isContainerTelcel && !isClaroPartner && this.state.isFocused && isValid && !serviceTA
                ? "1px solid #0071d1" 
                : validation.borderValidInvalidColor,
        }

        return(
            <Container
                background={isContainerTelcel && !isClaroPartner ? "#fff" : undefined}
                margin={isContainerTelcel && !isClaroPartner ? "2% 2% 15px 2%" : undefined}>
                <InputTitleClaroSocio 
                    {...title} 
                    type={type} 
                    handleClickTooltip={handleClickTooltip} 
                    isContainerTelcel={this.props.isContainerTelcel}
                    isFocused={this.state.isFocused}
                    serviceTA={serviceTA} />
                <ClaroDiv  {...styles}>
                    <ClaroInputField 
                        {...styles} 
                        constraints={constraints} 
                        value={value} 
                        onChange={(e) =>{
                            handleInputChange(e, type)
                            this.props.setNumberContact(undefined);
                            if(!this.props.inputValue){
                                this.handleValidateLength(e,this.props.input);
                            } 
                        }}
                        name={input.name}
                        placeholder={isClaroPartner && input.placeholderClaroSocio ?input.placeholderClaroSocio:input.placeholder}
                        id = {"pagoDeServicios_" + id + "_" + serviceName}
                        readOnly={input.disabled}
                        type={isClaroPartner && input.typeClaroSocio ? input.typeClaroSocio: input.type}
                        pattern="\d*"
                        //onInput={ (event) => {event.target.value = event.target.value.replace(/[^0-9]*/g,'')}}
                        phColor= {isContainerTelcel && !isClaroPartner ? "#757575" : "#c4c4c4"}
                        fontFamily = {isContainerTelcel && !isClaroPartner ? "AMX-Regular" : undefined}
                        fontSize = {isContainerTelcel && !isClaroPartner ? "14px" : undefined}
                        onFocus={()=>{this.setState({isFocused: true})}}
                        onBlur={()=>this.setState({isFocused: false})}
                        aria-describedby={!isFocused && !isValid ? "errorTooltip" : undefined}
                        autoComplete="off"
                    />
                    
                    {this.state.phoneNumber &&(

<>
    {alias && (
        <p style={{ position: 'absolute', fontSize:'13px', fontFamily:'AMX-Regular', right: '20px', top: '0%', color:'#a6ce4e', transform: 'translateY(-50%)' }}>
           <span style={{ fontWeight: 'bold' }}>{alias}</span>
        </p>
    )}


    {!alias && (
       <p
       style={{
           position: 'absolute',
           right: '16px',
           fontSize:'14px',
           fontFamily:'AMX-Regular',
           top: '10%',
           padding: '1px',
           transform: 'translateY(-50%)',
           color: '#329ebc', 
           fontWeight: 'bold', 
           textDecoration: 'underline', 
       }}
       onClick={this.handleImagenClick} 
   >
       Guardar Servicio 
   </p>
    )}
</>
)}
                    {
                        button && (!favoritos || !canManageFavorites) || (isContainerTelcel) ? (
                            <ClaroInputButton 
                                borderBottom={styles.borderBottom}
                                {...button}
                                onClick= {(e) =>{handleInputButtonFunction(e, type)}}
                            >
                                <Link 
                                    to={{
                                        pathname: '/contacts',
                                        state: {serviceId: serviceId, isContainerTelcel: isContainerTelcel, isClaroPartner: isClaroPartner}
                                    }}
                                >
                                    <ClaroImage {...button} isClaroPartner={isClaroPartner}  />
                                </Link>
                            </ClaroInputButton>
                        ):(<></>)
                    }
                </ClaroDiv>
                {
                    !isValid && isContainerTelcel &&
                    <HelpText id="errorTooltip" aria-live={"assertive"}>
                        <SrOnly>Error. </SrOnly>
                        Completa tu referencia
                    </HelpText>
                }
                <InputSubTitleClaroSocio {...subTitle} type={type} />
                {saveCard && (
                    <CreateFavoriteService
                        isFavoriteServices={true}
                        tagServiceId={tagServiceId}
                        accountService={phoneNumber}
                        isContainerTelcel={isContainerTelcel}
                        closeModalFavoriteServices={this.handleCloseModal}
                        hasFavs={true}
                    />
                )}
            </Container>
        )
    }
}

function mapStateToProps(state) {
    const { payments, favoritesRefReducer,payReminderReducer  } = state;
    const tagServiceId = getTagServiceId(payments);
    const listFavServices = getListFavsServices(favoritesRefReducer);
    const listReminder = getListReminder(payReminderReducer);
    const listRecentlyPaid = getListRecentlyPaid(payReminderReducer);
    return {
        favoriteServices: state,
        tagServiceId,
        listFavServices,
        listReminder,
        listRecentlyPaid,
        hasFavsSuccess: state.favoritesRefReducer.ResponseSuccess,
        isLoadingGetFavServices: state.favoritesRefReducer.isLoading,
        canManageFavorites: payments.canManageFavorites,
        getPaymentReminderSucess: state.payReminderReducer.getPaymentReminderSucess,
        isLoadingReminderReducerServices: state.payReminderReducer.isLoading,
        payments:payments,
        canPaymentReminder: payments.canPaymentReminder,
        numberFromAgenda: payments.numberFromAgenda
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            getFavoritosRef,
            deleteFavoritesRef,
            getPaymentReminder,
            executeTaggeo,
            setNumberContact
        },
        dispatch
    );
}

ContactInputClaroSocio = connect(
    mapStateToProps,
    mapDispatchToProps
)(ContactInputClaroSocio);